import { useAuth0 } from "@auth0/auth0-react";
import AuthenticationContext from "../../auth/AuthenticationContext";
import Layout from "./Layout";

const LayoutContainer = () => {
    const auth0Context = useAuth0();

    let authContext = new AuthenticationContext(auth0Context);

    return (
        <Layout authContext={authContext}  />
    )
}

export default LayoutContainer;